import * as angular from "angular";
import {IController} from "angular";

export class planningActivityPackedIndicationCtrl implements IController {

}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityPackedIndication', {
    bindings: {
      isPacked: '<',
      packages: '<?',
      stopType: '<?'
    },
    template: require('./planning-activity-packed-indication.html').default,
    controller: planningActivityPackedIndicationCtrl
  });
